import API from "../../../../src/components/api";
import * as React from 'react';
export default {
  API,
  React
};